import React, { useEffect, useState } from 'react';
import { WebsiteReportSummary } from './WebsiteReportSummary';
import { WebsiteReportSummaryVersionB } from './WebsiteReportSummaryVersionB';
import ReactGA from 'react-ga';

export const WebsiteReport = () => {
  const random = Math.floor(Math.random() * (100 - 1) + 1);
  const randomVersion = random < 50 ? 'A' : 'B';
  const storageVersion = localStorage.getItem('onboardingReportVersion') as
    | 'A'
    | 'B';
  const [version, setVersion] = useState<'A' | 'B'>(
    storageVersion || randomVersion,
  );

  useEffect(() => {
    if (!storageVersion) {
      localStorage.setItem('onboardingReportVersion', randomVersion);
    }
    if (
      storageVersion &&
      (storageVersion.toLocaleLowerCase() === 'a' ||
        storageVersion.toLocaleLowerCase() === 'b')
    ) {
      localStorage.setItem(
        'onboardingReportVersion',
        storageVersion.toUpperCase(),
      );
    }
    if (
      storageVersion &&
      storageVersion.toLocaleLowerCase() !== 'a' &&
      storageVersion.toLocaleLowerCase() !== 'b'
    ) {
      localStorage.setItem('onboardingReportVersion', 'B');
    }
    ReactGA.set({ page: `/onboarding-report-${version.toUpperCase()}` });
    ReactGA.pageview(`/onboarding-report-${version.toUpperCase()}`);
  });

  if (version.toLocaleLowerCase() === 'a') {
    return <WebsiteReportSummary />;
  }
  return <WebsiteReportSummaryVersionB />;
};
